import React from 'react';

const MetaAdsIcon: React.FC = () => (
  <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.99 12c0-3.23-2.1-6.1-5.12-7.23a.75.75 0 00-.76 1.3C18.78 7.09 20.49 9.39 20.49 12c0 2.61-1.71 4.91-4.38 5.93a.75.75 0 10.76 1.3C19.89 18.1 21.99 15.23 21.99 12zM8.63 6.07a.75.75 0 10-.76-1.3C4.85 5.9 2.75 8.77 2.75 12c0 3.23 2.1 6.1 5.12 7.23a.75.75 0 00.76-1.3C5.96 16.91 4.25 14.61 4.25 12c0-2.61 1.71-4.91 4.38-5.93z" />
  </svg>
);

export default MetaAdsIcon;